<template>
  <!--
    Example Data
   {
     name: 'service_count',
     input_type: :age_comparator_field,
     field_type: 'number',
     default: '87',
     unit_of_measure: 'years',
     label: 'new label',
     comparators: [=,<,>,etc]
     default_comparator: "="
    }

  -->
  <v-row>
    <v-col md="3">
      <div class="mr-5 mt-6">
        <div class="text-right subtitle font-weight-bold">{{ fieldLabel | capitalize }}</div>
      </div>
    </v-col>
    <v-col class="d-flex d-inline" md="9" >
      <v-select
        label="Condition"
        :items="availableComparators"
        :value="comparatorOrDefault"
        v-on:change="updateQueryParamValue(comparatorName, $event)"
        class="mr-6"
        :rules="vruleFieldRequired"
        required
      >
      </v-select>
      <v-text-field
        :label="value.name | titleize"
        :suffix="value.unit_of_measure"
        :type="value.field_type"
        :value="valOrDefault"
        v-on:change="updateQueryParamValue(value.name, $event)"
        class="mr-6"
        :rules="vruleFieldRequired"
        required
      >
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import validationMixin from '@/validators/validations_mixin'

// NOTE: This seems backward w/ indicators but they are correct
// my car is less than 2 years old ===  age > (current_year - 2)
const COMPARATORS_DESC = {
  '=': 'is',
  '!=': 'is not',
  '<': 'more than',
  '<=': 'more than or equal to',
  '>': 'less than',
  '>=': 'less than or equal to'
}

export default {
  name: 'comparator-field-input',
  inputType: 'age_comparator_field',
  mixins: [validationMixin],
  props: {
    value: {
      type: Object,
      require: true
    },
    paramName: {
      type: String,
      require: true
    },
    modelValue: {
      type: Object,
      require: true
    },
    errorMessages: {
      type: Array
    }
  },
  data: function () {
    return {}
  },
  computed: {
    valOrDefault () {
      if (this.modelValue[this.value.name]) {
        return this.modelValue[this.value.name]
      } else if (this.value.default) {
        this.updateQueryParamValue(this.value.name, this.value.default)
        return this.value.default
      } else {
        return ''
      }
    },
    comparatorName () {
      return `${this.value.name}_comparator`
    },
    comparatorOrDefault () {
      if (this.modelValue[this.comparatorName]) {
        return this.modelValue[this.comparatorName]
      } else if (this.value.default_comparator) {
        this.updateQueryParamValue(this.comparatorName, this.value.default_comparator)
        return this.value.default_comparator
      } else {
        return ''
      }
    },
    availableComparators () {
      return this.value.comparators.map((comparator) => {
        return { text: this.lookupComparator(comparator), value: comparator }
      })
    },
    fieldLabel () {
      return this.value.label || this.value.name
    }
  },
  methods: {
    updateQueryParamValue (key, value) {
      this.$emit('update-query-param-value', { name: this.paramName, key: key, value: value })
    },
    lookupComparator (comparator) {
      return COMPARATORS_DESC[comparator]
    }

  }
}
</script>
